import { IconService } from './ui-design-library/icon.service';

export function iconLibraryInitializer(iconService: IconService) {
  return (): void => {
      iconService.registerIcons();
  };
}